"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Auth = void 0;
var antd_1 = require("@iqmetrix/antd");
var React = __importStar(require("react"));
var react_1 = require("react");
var interfaces_1 = require("../interfaces");
var AuthClient_1 = require("./AuthClient");
var AuthContext_1 = require("./AuthContext");
var reducer = function (state, action) {
    var user = null;
    var env = null;
    var envSuffix = null;
    switch (action.type) {
        case interfaces_1.Action.StartLogIn:
            return __assign(__assign({}, state), { isLoading: true });
        case interfaces_1.Action.FinishLogIn:
            if (action.payload && typeof action.payload !== "string") {
                user = action.payload.user;
                env = action.payload.env;
                envSuffix = action.payload.envSuffix;
            }
            return __assign(__assign({}, state), { hasLoggedIn: true, isLoading: false, isLoaded: true, user: user,
                env: env,
                envSuffix: envSuffix });
        case interfaces_1.Action.FinishWithError:
            return __assign(__assign({}, state), { hasLoggedIn: false, isLoading: false, isLoaded: true, error: action.payload });
    }
};
var Auth = function (_a) {
    var children = _a.children;
    var _b = __read(react_1.useReducer(reducer, AuthContext_1.defaultState), 2), state = _b[0], dispatch = _b[1];
    react_1.useEffect(function () {
        if (!state.user) {
            dispatch({ type: interfaces_1.Action.StartLogIn });
            AuthClient_1.Client.setup()
                .then(function (data) {
                dispatch({ type: interfaces_1.Action.FinishLogIn, payload: data });
            })
                .catch(function (e) {
                console.error(e);
                dispatch({ type: interfaces_1.Action.FinishWithError, payload: e });
            });
        }
    }, [state.user]);
    return (React.createElement(antd_1.Skeleton, { loading: state.isLoading || !state.isLoaded }, state.hasLoggedIn ? (React.createElement(AuthContext_1.AuthContext.Provider, { value: state }, children)) : (React.createElement(antd_1.Result, { response: { status: 403, statusText: state.error } }))));
};
exports.Auth = Auth;
//# sourceMappingURL=Auth.js.map